module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('f7-accordion-item', {
    staticClass: "accordionForm",
    attrs: {
      "expanded": _vm.opened
    },
    on: {
      "accordion:open": function($event) {
        _vm.opened = true
      },
      "accordion:close": function($event) {
        _vm.opened = false
      }
    }
  }, [_c('f7-accordion-toggle', {
    staticClass: "accordionToggle"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "createInvoiceBand col-sm-auto text-uppercase"
  }, [(_vm.star) ? _c('span', {
    staticClass: "color-red"
  }, [_vm._v(" *")]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.title) + "\n              "), (_vm.opened) ? _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_down")]) : _vm._e(), _vm._v(" "), (!_vm.opened) ? _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")]) : _vm._e()])])]), _vm._v(" "), _c('f7-accordion-content', {
    class: {
      hasDatePicker: _vm.hasDatePicker
    }
  }, [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-738c3c01", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-738c3c01","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormAccordion.vue
// module id = 1692
// module chunks = 2